export const MSG_TYPE = {
  toMe: "to-me",
  fromMe: "from-me",
};
